"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXTableColumn = exports.DOCXTableRow = exports.DOCXTable = exports.HTMLTableColumn = exports.HTMLTableRow = exports.HTMLTable = exports.HTMLTableCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const paragraphItem_1 = require("./paragraphItem");
const columnsOrSentencesRun_1 = require("./columnsOrSentencesRun");
const articleGroup_1 = require("./articleGroup");
const article_1 = require("./article");
const std_1 = require("../../law/std");
const remarks_1 = require("./remarks");
const itemStruct_1 = require("./itemStruct");
const common_1 = require("../common");
exports.HTMLTableCSS = `
.table {
    border-collapse: collapse;
    text-indent: 0;
    table-layout: fixed;
    width: calc(100% - var(--margin-left));
}

.table-column {
    border: 1px solid black;
    min-height: 1em;
    height: 1em;
}

.table-header-column {
    border: 1px solid black;
    min-height: 1em;
    height: 1em;
}
`;
exports.HTMLTable = (0, html_1.wrapHTMLComponent)("HTMLTable", ((props) => {
    const { el, htmlOptions, indent } = props;
    const rows = [];
    for (const child of el.children) {
        if (std.isTableRow(child)
            || std.isTableHeaderRow(child)) {
            rows.push(react_1.default.createElement(exports.HTMLTableRow, { el: child, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement("table", { className: `table indent-${indent}`, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement("tbody", null, (0, common_1.withKey)(rows))));
}));
exports.HTMLTableRow = (0, html_1.wrapHTMLComponent)("HTMLTableRow", ((props) => {
    const { el, htmlOptions } = props;
    const columns = [];
    for (const child of el.children) {
        if (std.isTableColumn(child)
            || std.isTableHeaderColumn(child)) {
            columns.push(react_1.default.createElement(exports.HTMLTableColumn, { el: child, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement("tr", { className: "table-row", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(columns)));
}));
exports.HTMLTableColumn = (0, html_1.wrapHTMLComponent)("HTMLTableColumn", ((props) => {
    const { el, htmlOptions } = props;
    const blocks = [];
    if (std.isTableHeaderColumn(el)) {
        blocks.push((react_1.default.createElement("div", null,
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions }))));
    }
    else if (std.isTableColumn(el)) {
        if (el.children.every(std.isColumn)) {
            blocks.push((react_1.default.createElement("div", null,
                react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: el.children, htmlOptions }))));
        }
        else if (el.children.every(std.isSentence)) {
            for (const child of el.children) {
                blocks.push((react_1.default.createElement("div", null,
                    react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: [child], htmlOptions }))));
            }
        }
        else {
            for (const child of el.children) {
                if (child.tag === "Sentence" || child.tag === "Column") {
                    blocks.push((react_1.default.createElement("div", null,
                        react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: [child], htmlOptions }))));
                }
                else if (std.isFigStruct(child)) {
                    blocks.push(react_1.default.createElement(itemStruct_1.HTMLItemStruct, { el: child, indent: 0, htmlOptions }));
                }
                else if (std.isRemarks(child)) {
                    blocks.push(react_1.default.createElement(remarks_1.HTMLRemarks, { el: child, indent: 0, htmlOptions }));
                }
                else if (std.isArticleGroup(child)) {
                    blocks.push((react_1.default.createElement(articleGroup_1.HTMLArticleGroup, { el: child, indent: 0, htmlOptions })));
                }
                else if (std.isArticle(child)) {
                    blocks.push((react_1.default.createElement(article_1.HTMLArticle, { el: child, indent: 0, htmlOptions })));
                }
                else if (std.isParagraphItem(child)) {
                    blocks.push((react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: 0, htmlOptions })));
                }
                else {
                    (0, util_1.assertNever)(child);
                }
            }
        }
    }
    else {
        (0, util_1.assertNever)(el);
    }
    const style = {};
    if (el.attr.BorderTop)
        style.borderTopStyle = el.attr.BorderTop;
    if (el.attr.BorderBottom)
        style.borderBottomStyle = el.attr.BorderBottom;
    if (el.attr.BorderLeft)
        style.borderLeftStyle = el.attr.BorderLeft;
    if (el.attr.BorderRight)
        style.borderRightStyle = el.attr.BorderRight;
    if (el.attr.Align)
        style.textAlign = el.attr.Align;
    if (el.attr.Valign)
        style.verticalAlign = el.attr.Valign;
    const attr = {
        style,
        ...((el.attr.rowspan !== undefined) ? { rowSpan: Number(el.attr.rowspan) } : {}),
        ...((el.attr.colspan !== undefined) ? { colSpan: Number(el.attr.colspan) } : {}),
    };
    if (std.isTableHeaderColumn(el)) {
        return (react_1.default.createElement("th", { className: "table-header-column", ...attr, ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
    }
    else {
        return (react_1.default.createElement("td", { className: "table-column", ...attr, ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
    }
}));
const restructureTable = (table) => {
    const newTableChildren = [];
    const rowspanState = {};
    const colspanValue = {};
    for (const row of table.children) {
        const newRowChildren = [];
        let c = 0;
        let ci = 0;
        while (true) {
            const rss = rowspanState[c] || 0;
            if (rss) {
                const colspan = colspanValue[c] || 0;
                newRowChildren.push(std.newStdEL(std.isTableHeaderRow(row) ? "TableHeaderColumn" : "TableColumn", {
                    __merged: "__merged",
                    ...(colspan ? {
                        colspan: `${colspan}`,
                    } : {}),
                }, []));
                rowspanState[c] = rss - 1;
                if (colspan) {
                    c += colspan - 1;
                }
                c += 1;
                continue;
            }
            if (ci >= row.children.length) {
                break;
            }
            const column = row.children[ci];
            newRowChildren.push(column.copy(true));
            {
                const colspan = Number(column.attr.colspan || 0);
                if (column.attr.rowspan !== undefined) {
                    const rowspan = Number(column.attr.rowspan);
                    rowspanState[c] = rowspan - 1;
                    colspanValue[c] = colspan;
                    if (colspan) {
                        c += colspan - 1;
                    }
                }
                c += 1;
                ci += 1;
            }
        }
        newTableChildren.push((0, std_1.newStdEL)(row.tag, { ...row.attr }, newRowChildren));
    }
    const ret = (0, std_1.newStdEL)(table.tag, { ...table.attr }, newTableChildren);
    return ret;
};
exports.DOCXTable = (0, component_1.wrapDOCXComponent)("DOCXTable", ((props) => {
    const { el: origEL, docxOptions, indent } = props;
    const rows = [];
    const el = restructureTable(origEL);
    for (const child of el.children) {
        if (std.isTableRow(child)
            || std.isTableHeaderRow(child)) {
            rows.push(react_1.default.createElement(exports.DOCXTableRow, { el: child, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(tags_1.w.tbl, null,
        react_1.default.createElement(tags_1.w.tblPr, null,
            react_1.default.createElement(tags_1.w.tblStyle, { "w:val": `IndentTable${indent}` })),
        (0, common_1.withKey)(rows)));
}));
exports.DOCXTableRow = (0, component_1.wrapDOCXComponent)("DOCXTableRow", ((props) => {
    const { el, docxOptions } = props;
    const columns = [];
    for (const child of el.children) {
        if (std.isTableColumn(child)
            || std.isTableHeaderColumn(child)) {
            columns.push(react_1.default.createElement(exports.DOCXTableColumn, { el: child, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(tags_1.w.tr, null, (0, common_1.withKey)(columns)));
}));
const valignDict = {
    top: "top",
    middle: "center",
    bottom: "bottom",
};
const borderDict = {
    none: "nil",
    solid: "single",
    dotted: "dotted",
    double: "double",
};
exports.DOCXTableColumn = (0, component_1.wrapDOCXComponent)("DOCXTableColumn", ((props) => {
    const { el, docxOptions } = props;
    const blocks = [];
    if (std.isTableHeaderColumn(el)) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: el.children, docxOptions }))));
    }
    else if (std.isTableColumn(el)) {
        if (el.children.every(std.isColumn)) {
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: el.children, docxOptions }))));
        }
        else if (el.children.every(std.isSentence)) {
            for (const child of el.children) {
                blocks.push((react_1.default.createElement(tags_1.w.p, null,
                    react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: [child], docxOptions }))));
            }
        }
        else {
            for (const child of el.children) {
                if (child.tag === "Sentence" || child.tag === "Column") {
                    blocks.push((react_1.default.createElement(tags_1.w.p, null,
                        react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: [child], docxOptions }))));
                }
                else if (std.isFigStruct(child)) {
                    blocks.push(react_1.default.createElement(itemStruct_1.DOCXItemStruct, { el: child, indent: 0, docxOptions }));
                }
                else if (std.isRemarks(child)) {
                    blocks.push(react_1.default.createElement(remarks_1.DOCXRemarks, { el: child, indent: 0, docxOptions }));
                }
                else if (std.isArticleGroup(child)) {
                    blocks.push((react_1.default.createElement(articleGroup_1.DOCXArticleGroup, { el: child, indent: 0, docxOptions })));
                }
                else if (std.isArticle(child)) {
                    blocks.push((react_1.default.createElement(article_1.DOCXArticle, { el: child, indent: 0, docxOptions })));
                }
                else if (std.isParagraphItem(child)) {
                    blocks.push((react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: 0, docxOptions })));
                }
                else {
                    (0, util_1.assertNever)(child);
                }
            }
        }
    }
    else {
        (0, util_1.assertNever)(el);
    }
    if (el.attr.__merged !== undefined) {
        return (react_1.default.createElement(tags_1.w.tc, null,
            react_1.default.createElement(tags_1.w.tcPr, null,
                (el.attr.colspan !== undefined) && react_1.default.createElement(tags_1.w.gridSpan, { "w:val": el.attr.colspan }),
                react_1.default.createElement(tags_1.w.vMerge, null)),
            react_1.default.createElement(tags_1.w.p, null)));
    }
    else {
        return (react_1.default.createElement(tags_1.w.tc, null,
            react_1.default.createElement(tags_1.w.tcPr, null,
                (el.attr.colspan !== undefined) && react_1.default.createElement(tags_1.w.gridSpan, { "w:val": el.attr.colspan }),
                (el.attr.rowspan !== undefined) && react_1.default.createElement(tags_1.w.vMerge, { "w:val": "restart" }),
                (el.attr.Align !== undefined) && react_1.default.createElement(tags_1.w.jc, { "w:val": el.attr.Align }),
                (el.attr.Valign !== undefined) && react_1.default.createElement(tags_1.w.vAlign, { "w:val": valignDict[el.attr.Valign] }),
                ((el.attr.BorderTop ?? el.attr.BorderBottom ?? el.attr.BorderLeft ?? el.attr.BorderRight) !== undefined) && (react_1.default.createElement(tags_1.w.tcBorders, null,
                    (el.attr.BorderTop !== undefined) && react_1.default.createElement(tags_1.w.top, { "w:val": borderDict[el.attr.BorderTop] }),
                    (el.attr.BorderBottom !== undefined) && react_1.default.createElement(tags_1.w.bottom, { "w:val": borderDict[el.attr.BorderBottom] }),
                    (el.attr.BorderLeft !== undefined) && react_1.default.createElement(tags_1.w.left, { "w:val": borderDict[el.attr.BorderLeft] }),
                    (el.attr.BorderRight !== undefined) && react_1.default.createElement(tags_1.w.right, { "w:val": borderDict[el.attr.BorderRight] })))),
            (0, common_1.withKey)(blocks)));
    }
}));
//# sourceMappingURL=table.js.map